import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ormCalculations from "../../../hooks/api/calculate";
import ORMfunctions from "../../../hooks/app/general";
import { type RootState } from "../../../store/store";
import {
  setPriceLoading,
  setPriceSuccess,
  setPriceError,
} from "../../../store/orm/userSession";
import { convertCurrency } from "../../../utils/formater";

export function Calcprice({ id }: { id: string }) {
  const dispatch = useDispatch();
  const userSession = useSelector((state: RootState) => state.userSession);

  const prices = userSession.prices || {};
  const pricesLoading = userSession.pricesLoading || {};

  useEffect(() => {
    if (!id) return;
    if (!userSession.selectedStation) return;

    if (prices[id] !== undefined) {
      return;
    }

    if (pricesLoading[id]) {
      return;
    }

    dispatch(setPriceLoading(id));

    ormCalculations
      .calculate(userSession, true, id)
      .then((res) => {
        dispatch(setPriceSuccess({ id, data: res }));
      })
      .catch((err) => {
        console.error(`❌ Calculation failed for ${id}:`, err);
        dispatch(setPriceError(id));
      });
  }, [id, userSession.selectedStation, dispatch]);

  // Verwende die defensive Variable
  const price = prices[id];
  const isLoading = pricesLoading[id];

  if (isLoading) {
    return (
      <div className="orm-carprice orm-carprice--loading">
        <span className="orm-price__loader"></span>
      </div>
    );
  }

  // If price is null or undefined, we don't render
  if (price === null || price === undefined) return null;

  return (
    <div className="orm-carprice">
      <div className="orm-price__txt__surtitle">
        {ORMfunctions.i18n("cargroup/unitbefore")} {price.unit}{" "}
        {ORMfunctions.i18n("cargroup/unitafter")}
      </div>
      <div className="orm-price__txt">{convertCurrency(price.price)}</div>
    </div>
  );
}

export default Calcprice;
